export function mapPackageOptionsToServices(services, packageOptions) {
  if (!services) return [];

  return services.map((service) => {
    const serviceOptionTitles = [];
    const serviceOptionPrices = [];

    packageOptions.forEach((serviceOption, indexServiceOption) => {
      if (serviceOption.serviceId !== +service.id) return;

      if (serviceOption.servicePrice) {
        serviceOptionPrices[indexServiceOption] = +serviceOption.servicePrice;
      }

      if (!serviceOption.serviceVariants || serviceOption.serviceVariants.length === 0) return;

      serviceOption.serviceVariants.forEach((serviceVariant) => {
        if (!serviceVariant.variants || serviceVariant.variants.length === 0) return;

        serviceVariant.variants.forEach((variant, indexVariant) => {
          if (!variant.isVariantSelected) return;
          serviceOptionTitles[indexVariant] = variant.title;
          serviceOptionPrices[indexVariant] = +variant.price;
        });
      });
    });

    const servicePrices = serviceOptionPrices.length > 0
      ? serviceOptionPrices.reduce((sum, current) => sum + current, 0)
      : undefined;

    const mainOption = serviceOptionTitles.length > 0 ? serviceOptionTitles[0] : undefined;
    if (serviceOptionTitles.length > 0) serviceOptionTitles.shift();
    const extraOption = serviceOptionTitles.length > 0
      ? serviceOptionTitles.toString()
      : undefined;

    return {
      id: service.id,
      name: service.name,
      shortDescription: service.shortDescription,
      description: service.description,
      provider: service.provider,
      servicePrices,
      mainOption,
      extraOption,
    };
  });
}

export function calculatePackagePrice(services, fallbackPrice) {
  const packagePrice = services
    .map((service) => service.servicePrices)
    .reduce((sum, current) => sum + current, 0);

  return Number.isNaN(packagePrice) ? fallbackPrice : packagePrice;
}
